import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { Badge, Card, Col, Form, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  RSelect,
} from "../../components/Component";

import { toast, ToastContainer } from "react-toastify";
import Loader from "../../app/Loader";
import { kycInfo, uploadKyc, getUserInfo, getDocumentType } from "../../app/api";

const UserKYC = ({ sm, updateSm }) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [userCountry, setUserCountry] = useState("");
  const [kycdata, setKycData] = useState({
    photo_verified: 0,
    photo_id_verified: 0,
    pan_verified: 0,
  });
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [idNumber, setIdNumber] = useState(null);
  const [error, setError] = useState('');
  const [errorDoc, setErrorDoc] = useState('');
  const [errorPan, setErrorPan] = useState('');
  const [panNumber, setPanNumber] = useState(null);
  const [modal, setModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [fileSelected, setFileSelected] = useState(false);
  const [docName, setDocName] = useState("");
  const [frontPreview, setFrontPreview] = useState(null);
  const [backPreview, setBackPreview] = useState(null);
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [userPhoto, setUserPhoto] = useState("");
  const [userPhotoId, setUserPhotoId] = useState("");
  const [userPhotoIdBack, setUserPhotoIdBack] = useState("");
  const [userPan, setUserPanPhoto] = useState("");
  const [docType, setDocType] = useState("");

  const fetchDocumentTypes = async () => {
    const res = await getDocumentType();
    if (res.code === 200) {
      setDocumentTypes(res.data);
    }
  };

  const dropdownSource = documentTypes.map((doc) => ({
    value: doc.id,
    label: doc.doc_name
  }));

  const validateDoc = (value) => {
    if (!value || value.trim() === "") {
      setErrorDoc("Please enter document number");
      setIdNumber(value);
    }
    else if (value.length > 20) {
      setErrorDoc("Document number cannot exceed 20 characters");
      setIdNumber(value);
    }
    else {
      setErrorDoc("");
      setIdNumber(value);
    }
  };

  const validatePan = (value) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!value || value.trim() === "") {
      setErrorPan("Please enter PAN number");
      setPanNumber(null);
    } else if (!panRegex.test(value)) {
      setErrorPan("Invalid PAN number format");
      setPanNumber(null);
    } else {
      setErrorPan("");
      setPanNumber(value);
    }
  }

  const kycInfoData = async () => {
    setLoading(true);
    let uid = localStorage.getItem("uid");

    let res = await kycInfo({
      uid: uid,
    });
    if (res.code == 200) {
      setKycData(prev => ({
        ...prev,
        ...res.data,
      }));
      setIdNumber(res.data.doc_number || "");
      setPanNumber(res.data.pan_number || "");
      setUserPhoto(res.data.user_photo || "");
      setUserPhotoId(res.data.user_photo_id || "");
      setUserPhotoIdBack(res.data.user_photo_id_back_side || "");
      setUserPanPhoto(res.data.user_pan || "");
      setDocType(res.data.doc_type);
    }

    let res2 = await getUserInfo(uid);

    if (res2) {
      setUserCountry(res2.country);
    }

    setLoading(false);
  };

  const validateFile = (file, type, side, setPreview) => {
    const ext = file.type.split("/")[1]?.toLowerCase();
    const size = Math.round(file.size / 1024);

    if (!["jpeg", "jpg", "png"].includes(ext)) {
      toast.dismiss();
      toast.error("You can upload jpg, png, and jpeg files only.");
      setFrontPreview(null);
      setBackPreview(null);
      return false;
    }

    if (size > 300) {
      toast.dismiss();
      toast.error("Image file size is too large. Maximum file size is 300KB");
      if (type == "photo") {
        setFrontPreview(null);
        setFileSelected(false);
      } else if (type == "pan") {
        setFrontPreview(null);
        setUserPanPhoto(null);
      } else if (type == "photo_id" && side == "front") {
        setFrontPreview(null);
        setFrontFile(null);
      } else if (type == "photo_id" && side == "back") {
        setBackPreview(null);
        setBackFile(null);
      }
      return false;
    }

    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);

    return true;
  };


  const uploadImage = async () => {
    const docType = selectedDocument?.value;
    if (docName === "photo_id") {
      if (!selectedDocument) {
        setError("Please select document type");
        return;
      }
      if (!idNumber) {
        setErrorDoc("Please enter document number");
        return;
      }
      if (idNumber.length > 20) {
        setErrorDoc("Document number cannot exceed 20 characters");
        return;
      }
      if (!frontFile) {
        toast.dismiss();
        toast.error("Please select a front side file to upload.");
        return;
      }

      // Back side required only if docType is NOT 4 or 5
      if (docType !== 4 && docType !== 5) {
        if (!backFile) {
          toast.dismiss();
          toast.error("Please select a back side file to upload.");
          return;
        }
      }
    }
    if (docName === "pan") {
      if (!panNumber || panNumber.trim() === "") {
        setErrorPan("Please enter PAN number");
        return;
      }
      if (!userPan) {
        toast.dismiss();
        toast.error("Please select a file to upload.");
        return;
      }
    }

    if (!fileSelected) {
      toast.dismiss();
      toast.error("Please select a file to upload.");
      return;
    }

    if (isUploading) return;

    setIsUploading(true);

    const uid = localStorage.getItem("uid");
    const uinfo = await getUserInfo(uid);

    if (
      uinfo.city == null ||
      uinfo.address_line1 == null ||
      !uinfo.city.trim() ||
      !uinfo.address_line1.trim()
    ) {
      toast.dismiss();
      toast.error("Please update your profile first");
      return;
    }

    if (localStorage.getItem("mail_verified") === "0") {
      toast.dismiss();
      toast.error("Please verify your email id first");
      return;
    }
    setLoading(true);

    const form = new FormData();
    let hasError = false;

    // Handle photo upload
    if (file) {
      const ext = file.type.split("/")[1].toLowerCase();
      const size = Math.round(file.size / 1024);

      if (["jpeg", "jpg", "png"].includes(ext) && size <= 300) {
        form.append("user_photo", file, file.name);
        // kycdata.photo_verified = 1;
      } else {
        hasError = true;
        toast.dismiss();
        toast.error("Image file size is too large or invalid format.");
        setFile("");
      }
    }

    // Handle photo ID upload
    if (frontFile) {
      const ext = frontFile.type.split("/")[1].toLowerCase();
      const size = Math.round(frontFile.size / 1024);

      if (["jpeg", "jpg", "png"].includes(ext) && size <= 300) {
        form.append("user_photo_id", frontFile, frontFile.name);
        form.append("doc_type", selectedDocument ? selectedDocument.value : "");
        form.append("doc_number", idNumber ? idNumber : "");
        // kycdata.photo_id_verified = 1;
      } else {
        hasError = true;
        toast.dismiss();
        toast.error("Image file size is too large or invalid format.");
        setFrontFile(null);
      }
    }
    if (backFile) {
      const ext1 = backFile.type.split("/")[1].toLowerCase();
      const size1 = Math.round(backFile.size / 1024);
      if (["jpeg", "jpg", "png"].includes(ext1) && size1 <= 300) {
        form.append("user_photo_id_back", backFile, backFile.name);
        // kycdata.photo_id_verified = 1;
      } else {
        hasError = true;
        toast.error("Image file size is too large or invalid format.");
        setBackFile(null);
      }
    }

    // Handle PAN card upload
    if (userPan) {
      const ext = userPan.type.split("/")[1].toLowerCase();
      const size = Math.round(userPan.size / 1024);

      if (["jpeg", "jpg", "png"].includes(ext) && size <= 300) {
        form.append("user_pan", userPan, userPan.name);
        form.append("pan_number", panNumber ? panNumber : "");
        // kycdata.pan_verified = 1;
      } else {
        hasError = true;
        toast.dismiss();
        toast.error("Image file size is too large or invalid format.");
        setUserPanPhoto(null);
      }
    }

    if (!hasError) {
      form.append("uid", uid);
      form.append("doc_name", docName);
      const res = await uploadKyc(form);
      if (res.code === 200) {
        toast.dismiss();
        toast.success("KYC Detail Uploaded Successfully.");
        await kycInfoData();
        setFrontPreview(null);
        setModal(false);
        setFrontFile(null);
        setFile("");
        setBackFile(null);
        setUserPanPhoto(null);
      }
    }

    setLoading(false);
    setIsUploading(false); // Reset uploading flag
  };

  useEffect(() => {
    fetchDocumentTypes();
    kycInfoData();
  }, []);

  useEffect(() => {
    if (documentTypes.length > 0 && kycdata?.doc_type) {
      const foundDoc = documentTypes.find(doc => doc.id === kycdata.doc_type);
      if (foundDoc) {
        setSelectedDocument({
          value: foundDoc.id,
          label: foundDoc.doc_name,
        });
      }
    }
  }, [documentTypes, kycdata]);

  return (
    <React.Fragment>
      <Head title="KYC Document"></Head>

      <BlockHead size="lg">
        <Loader visible={loading} />
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle tag="h4">KYC Document</BlockTitle>
            <BlockDes>
              <p>Please Complete KYC to Receive Payments</p>
            </BlockDes>
          </BlockHeadContent>
          <BlockHeadContent className="align-self-start d-lg-none">
            <Button
              className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                }`}
              onClick={() => updateSm(!sm)}
            >
              <Icon name="menu-alt-r"></Icon>
            </Button>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>

      <Block>
        <Card className="card-bordered">
          <div className="card-inner-group">
            {kycdata.photo_verified == 1 ? (
              <div className="card-inner">
                <div className="between-center flex-wrap g-3">
                  <div className="nk-block-text">
                    <h6>Profile Photo Uploaded</h6>
                    <p>Your Photo uploaded and waiting for approval</p>
                  </div>
                  <div className="nk-block-actions flex-shrink-sm-0">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                      <li className="order-md-last">
                        <Badge className="badge-dim" color="warning">
                          Waiting for approval
                        </Badge>
                      </li>
                      <li className="order-md-last">
                        <Button
                          color="primary"
                          onClick={() => {
                            setViewModal(true);
                            setDocName("photo");
                          }}
                        >
                          <Icon name="eye" />&nbsp; View
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : kycdata.photo_verified == 2 ? (
              <div className="card-inner">
                <div className="between-center flex-wrap g-3">
                  <div className="nk-block-text">
                    <h6>Profile Photo Uploaded</h6>
                    <p>Your Photo uploaded and accepted</p>
                  </div>
                  <div className="nk-block-actions flex-shrink-sm-0">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                      <li className="order-md-last">
                        <Badge className="badge-dim" color="success">
                          Accepted
                        </Badge>
                      </li>
                      <li className="order-md-last">
                        <Button
                          color="primary"
                          onClick={() => {
                            setViewModal(true);
                            setDocName("photo");
                          }}
                        >
                          <Icon name="eye" />&nbsp; View
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card-inner">
                <div className="between-center flex-wrap g-3">
                  <div className="nk-block-text">
                    <h6>Upload Profile Photo</h6>
                    <p>
                      {kycdata.photo_verified == 3 ? (
                        <div
                          className="alert alert-danger alert-dim mr-4 p-0 px-1 fs-5"
                          style={{ fontSize: 12, border: "none" }}
                          color="danger"
                        >
                          Your document rejected please upload again.
                          {kycdata.user_photo_remark &&
                            " Reason - " + kycdata.user_photo_remark}
                        </div>
                      ) : (
                        "Upload your passport size photo"
                      )}
                    </p>
                  </div>
                  <div className="nk-block-actions flex-shrink-sm-0">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                      {kycdata.photo_verified == 3 && (
                        <li className="order-md-last">
                          <Button
                            color="primary"
                            onClick={() => {
                              setViewModal(true);
                              setDocName("photo");
                            }}
                          >
                            <Icon name="eye" />&nbsp; View
                          </Button>
                        </li>
                      )}
                      <li className="order-md-last">
                        <Button
                          color="primary"
                          onClick={() => {
                            setModal(true);
                            setDocName("photo");
                          }}
                        >
                          <Icon name="upload" />&nbsp; {kycdata.photo_verified == 3 ? "Re-upload" : "Upload"}
                        </Button>

                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {kycdata.photo_id_verified == 1 ? (
              <div className="card-inner">
                <div className="between-center flex-wrap g-3">
                  <div className="nk-block-text">
                    <h6>Government ID Uploaded</h6>
                    <p>Your photo id uploaded and waiting for approval</p>
                  </div>
                  <div className="nk-block-actions flex-shrink-sm-0">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                      <li className="order-md-last">
                        <Badge className="badge-dim" color="warning">
                          Waiting for approval
                        </Badge>
                      </li>
                      <li className="order-md-last">
                        <Button
                          color="primary"
                          onClick={() => {
                            setViewModal(true);
                            setDocName("photo_id");
                          }}
                        >
                          <Icon name="eye" />&nbsp; View
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : kycdata.photo_id_verified == 2 ? (
              <div className="card-inner">
                <div className="between-center flex-wrap g-3">
                  <div className="nk-block-text">
                    <h6>Government ID Uploaded</h6>
                    <p>Photo id uploaded and accepted</p>
                  </div>
                  <div className="nk-block-actions flex-shrink-sm-0">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                      <li className="order-md-last">
                        <Badge className="badge-dim" color="success">
                          Accepted
                        </Badge>
                      </li>
                      <li className="order-md-last">
                        <Button
                          color="primary"
                          onClick={() => {
                            setViewModal(true);
                            setDocName("photo_id");
                          }}
                        >
                          <Icon name="eye" />&nbsp; View
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card-inner">
                <div className="between-center flex-wrap g-3">
                  <div className="nk-block-text">
                    <h6>Upload Government ID</h6>
                    <p>
                      {kycdata.photo_id_verified == 3 ? (
                        <div
                          className="alert alert-danger alert-dim mr-4 p-0 px-1 fs-5"
                          style={{ fontSize: 12, border: "none" }}
                          color="danger"
                        >
                          Your document rejected please upload again.
                          {kycdata.user_photo_id_remark &&
                            " Reason - " + kycdata.user_photo_id_remark}
                        </div>
                      ) : (
                        "A government issued photo id proof"
                      )}
                    </p>
                  </div>
                  <div className="nk-block-actions flex-shrink-sm-0">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                      <li className="order-md-last">
                        {kycdata.photo_id_verified == 3 && (
                          <Button
                            className="mr-3"
                            color="primary"
                            onClick={() => {
                              setViewModal(true);
                              setDocName("photo_id");
                            }}
                          >
                            <Icon name="eye" />&nbsp; View
                          </Button>
                        )}
                        <Button color="primary"
                          onClick={() => {
                            setModal(true);
                            setDocName("photo_id");
                          }}
                        ><Icon name="upload" />&nbsp; {kycdata.photo_id_verified == 3 ? "Re-upload" : "Upload"}
                        </Button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {/* PAN Card Section */}
            {userCountry.toLowerCase() === "india" &&
              (kycdata.pan_verified == 1 ? (
                <div className="card-inner">
                  <div className="between-center flex-wrap g-3">
                    <div className="nk-block-text">
                      <h6>Uploaded PAN Card</h6>
                      <p>Your PAN Card uploaded and waiting for approval</p>
                    </div>
                    <div className="nk-block-actions flex-shrink-sm-0">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                        <li className="order-md-last">
                          <Badge className="badge-dim" color="warning">
                            Waiting for approval
                          </Badge>
                        </li>
                        <li className="order-md-last">
                          <Button
                            color="primary"
                            onClick={() => {
                              setViewModal(true);
                              setDocName("pan");
                            }}
                          >
                            <Icon name="eye" />&nbsp; View
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ) : kycdata.pan_verified == 2 ? (
                <div className="card-inner">
                  <div className="between-center flex-wrap g-3">
                    <div className="nk-block-text">
                      <h6>Uploaded PAN Card</h6>
                      <p>Your PAN Card uploaded and accepted</p>
                    </div>
                    <div className="nk-block-actions flex-shrink-sm-0">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                        <li className="order-md-last">
                          <Badge className="badge-dim" color="success">
                            Accepted
                          </Badge>
                        </li>
                        <li className="order-md-last">
                          <Button
                            color="primary"
                            onClick={() => {
                              setViewModal(true);
                              setDocName("pan");
                            }}
                          >
                            <Icon name="eye" />&nbsp; View
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="card-inner">
                  <div className="between-center flex-wrap g-3">
                    <div className="nk-block-text">
                      <h6>Upload PAN Card</h6>
                      <p>
                        {kycdata.pan_verified == 3 ? (
                          <div
                            className="alert alert-danger alert-dim mr-4 p-0 px-1 fs-5"
                            style={{ fontSize: 12, border: "none" }}
                            color="danger"
                          >
                            Your document rejected please upload again.
                            {kycdata.user_pan_remark &&
                              " Reason - " + kycdata.user_pan_remark}
                          </div>
                        ) : (
                          "Upload your PAN Card"
                        )}
                      </p>
                    </div>
                    <div className="nk-block-actions flex-shrink-sm-0">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                        <li className="order-md-last">
                          {kycdata.user_pan && (
                            <Button
                              className="mr-3"
                              color="primary"
                              onClick={() => {
                                setViewModal(true);
                                setDocName("pan");
                              }}
                            >
                              <Icon name="eye" />&nbsp; View
                            </Button>
                          )}
                          <Button
                            color="primary"
                            onClick={() => {
                              setModal(true);
                              setDocName("pan");
                            }}
                          >
                            <Icon name="upload" />&nbsp; {kycdata.pan_verified == 3 ? "Re-upload" : "Upload"}
                          </Button>

                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </Card>
        <Modal
          isOpen={modal}
          toggle={() => setModal(false)}
          className="modal-dialog-centered kyc-modal"
          size="lg"
          backdrop="static"
        >
          <ModalBody>
            <button
              type="button"
              className="close"
              onClick={() => {
                setModal(false);
                setFrontPreview(null);
                setBackPreview(null);
                setFile("");
                setFileSelected(false);
                setFrontFile(null);
                setBackFile(null);
                setUserPanPhoto(null);
              }}
            >
              <Icon name="cross-sm"></Icon>
            </button>
            <div className="kyc-wrapper">
              <h4 className="text-center mb-1">{docName === "photo" ? "Upload Profile Photo" : docName === "photo_id" ? "Upload Government ID" : "Upload PAN Card"}</h4>
              <p className="text-center text-muted mb-4">
                Please Complete KYC to Receive Payments
              </p>
              <Form>
                <Col md="12">
                  <div className="kyc-card">
                    <div className="kyc-card-header">
                      <i className="icon ni ni-camera"></i>
                      <span>{docName === "photo" ? "Profile photo" : docName === "photo_id" ? "Government ID" : "PAN Card"}</span>
                    </div>
                    <hr />
                    {docName === "photo_id" && (
                      <FormGroup>
                        {/* Document Type */}
                        <div className="form-control-wrap">
                          <label className="form-label">Document Type</label>
                          <RSelect
                            options={dropdownSource}
                            value={selectedDocument}
                            onChange={(selected) => {
                              setError("");
                              setSelectedDocument(selected);
                            }}
                            placeholder="Select Document"
                          />
                          {error && <span className="text-danger">{error}</span>}
                        </div>

                        {/* Document Number */}
                        <div className="form-control-wrap mt-3">
                          <label className="form-label">Document Number</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Document Number"
                            value={idNumber || ""}
                            onChange={(e) => validateDoc(e.target.value)}
                          />
                          {errorDoc && <span className="text-danger">{errorDoc}</span>}
                        </div>
                      </FormGroup>
                    )}
                    {docName === "pan" && (
                      <div className="form-control-wrap mt-3">
                        <label className="form-label">PAN Number</label>
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="PAN Number"
                          onChange={(e) => {
                            // validatePan(e.target.value);
                            const upperCaseValue = e.target.value.toUpperCase();
                            validatePan(upperCaseValue);
                            e.target.value = upperCaseValue;
                          }}
                          defaultValue={panNumber ? panNumber : ""}
                        />
                        {errorPan && (<span className="text-danger">{errorPan}</span>)}
                      </div>
                    )}
                    <p className="kyc-desc mt-3">
                      {docName === "photo"
                        ? "Upload a clear, recent photo of your face. Ensure good lighting and face is clearly visible."
                        : docName === "photo_id"
                          ? "Upload a clear, recent photo of your Photo ID. Ensure good lighting and text is clearly visible."
                          : "Upload a clear, recent photo of your PAN card. Ensure good lighting and text is clearly visible."}
                    </p>
                    <FormGroup>
                      <Label className="upload-box">
                        <Input
                          type="file"
                          accept="image/png, image/jpeg"
                          hidden
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file && validateFile(file, docName, "front", setFrontPreview)) {
                              setFrontFile(file);
                              setFile(file);
                              setFileSelected(true);
                              setUserPanPhoto(file);
                            }
                            e.target.value = null;
                          }}
                        />

                        {frontPreview ? (
                          <div className="upload-preview">
                            <img src={frontPreview} alt="Front Preview" />
                          </div>
                        ) : (
                          <div className="upload-inner">
                            <i className="icon ni ni-upload-cloud"></i>
                            <p className="mb-0 fw-500">Upload Front Side</p>
                            <small className="text-muted">JPG, PNG up to 300KB</small>
                          </div>
                        )}
                      </Label>
                    </FormGroup>
                    <FormGroup>
                      {docName === "photo_id" && selectedDocument?.value !== 4 && (
                        <Label className="upload-box">
                          <Input
                            type="file"
                            accept="image/png, image/jpeg"
                            hidden
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file && validateFile(file, docName, "back", setBackPreview)) {
                                setBackFile(file);
                              }
                              e.target.value = null;
                            }}
                          />

                          {backPreview ? (
                            <div className="upload-preview">
                              <img src={backPreview} alt="Back Preview" />
                            </div>
                          ) : (
                            <div className="upload-inner">
                              <i className="icon ni ni-upload-cloud"></i>
                              <p className="mb-0 fw-500">Upload Back Side</p>
                              <small className="text-muted">JPG, PNG up to 300KB</small>
                            </div>
                          )}
                        </Label>
                      )}
                    </FormGroup>


                    {/* Tips */}
                    {docName === "photo" ? (
                      <div className="kyc-tip">
                        <i className="icon ni ni-info"></i>
                        Tips: Remove glasses/hats, face the camera directly, use natural lighting
                      </div>
                    ) : (
                      <div className="kyc-tip">
                        <i className="icon ni ni-info"></i>
                        Tips: Ensure all text is clear and legible, avoid glare, use a plain background
                      </div>
                    )}
                  </div>

                  {/* Footer buttons */}
                  <div className="kyc-footer">
                    <Button
                      type="button"
                      color="light"
                      onClick={() => {
                        setModal(false);
                        setFrontPreview(null);
                        setBackPreview(null);
                        setFileSelected(false);
                        setFrontFile(null);
                        setFile("");
                        setBackFile(null);
                        setUserPanPhoto(null);
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      color="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        uploadImage();
                        setFile("");
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </Col>
              </Form>
            </div>
          </ModalBody>
        </Modal>

        {/* view documents modal */}

        <Modal
          isOpen={viewModal}
          toggle={() => setViewModal(false)}
          className="modal-dialog-centered kyc-modal"
          size="lg"
          backdrop="static"
        >
          <ModalBody>
            <button
              type="button"
              className="close"
              onClick={() => {
                setViewModal(false);
              }}
            >
              <Icon name="cross-sm"></Icon>
            </button>
            <div className="kyc-wrapper">
              <h4 className="text-center mb-1">{docName === "photo" ? "Uploaded Profile Photo" : docName === "photo_id" ? "Uploaded Government ID" : "Upload PAN Card"}</h4>
              <Col md="12">
                <div className="kyc-card">
                  <div className="kyc-card-header">
                    <i className="icon ni ni-camera"></i>
                    <span>{docName === "photo" ? "Profile photo" : docName === "photo_id" ? "Government ID" : "PAN Card"}</span>
                  </div>
                  <hr />
                  {docName === "photo_id" && (
                    <FormGroup>
                      {/* Document Type */}
                      {selectedDocument && (
                        <div className="form-control-wrap">
                          <label className="form-label">Document Type : {selectedDocument?.label}</label>
                        </div>
                      )}

                      {/* Document Number */}
                      {idNumber && (
                        <div className="form-control-wrap mt-3">
                          <label className="form-label">Document Number : {idNumber}</label>
                        </div>
                      )}
                    </FormGroup>
                  )}
                  {docName === "pan" && panNumber && (
                    <div className="form-control-wrap mt-3">
                      <label className="form-label">PAN Number : {panNumber}</label>
                    </div>
                  )}
                  <Label className="upload-box">
                    <div className="upload-preview">
                      <img src={docName === "photo" ? userPhoto : docName === "photo_id" ? userPhotoId : userPan} alt="Front Preview" />
                    </div>
                  </Label>
                  {((docName === "photo_id" && userPhotoIdBack !== "" && selectedDocument?.value !== 4 && selectedDocument?.value !== 5) ||
                    (selectedDocument?.value === 5 && userPhotoIdBack !== "" && docName === "photo_id")) && (
                      <Label className="upload-box">
                        <div className="upload-preview">
                          <img src={docName === "photo_id" ? userPhotoIdBack : ""} alt="Back Preview" />
                        </div>
                      </Label>
                    )}
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal>
      </Block>
    </React.Fragment >
  );
};
export default UserKYC;
